"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToastWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const react_toastify_1 = require("react-toastify");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledToastWrapper = (0, styled_components_1.default)(react_toastify_1.ToastContainer) `
  &&&.Toastify__toast-container {
    min-height: ${theme_1.spacings.s10};
    min-width: ${(0, utils_1.pxToRem)(352)};
    width: max-content;
    border-radius: 8px;

    @media (max-width: 480px) {
      top: 32px;
      left: 50%;
      transform: translateX(-50%);
      width: 85vw;
      min-width: 335px;
    }
  }
  .Toastify__toast {
    padding: 0;
    min-height: ${theme_1.spacings.s10};
    border-radius: 8px;
  }
  .Toastify__toast-body {
    padding: 0;
    min-height: ${theme_1.spacings.s10};
  }
  .Toastify__progress-bar {
    border-radius: ${`0 0 0 ${theme_1.spacings.s2}`};
  }
  .Toastify__close-button,
  .Toastify__toast-icon {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map